import React from "react";
import { Box, Paper, Typography, LinearProgress } from "@mui/material";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import PrimaryButton from "../../../../../Components/Atoms/Buttons/Primary/PrimaryButton";
import DownloadSection from "../DownloadSection/DownloadSection";
import TimerSection from "../TimerSection/TimerSection";
import config from "../../../../../config";
import { FILE_UPLOAD } from "../../Constants/missionConstants";

function FileUploadInterface({
  mission,
  timeLeft,
  selectedFile,
  uploadStatus,
  uploading,
  uploadProgress,
  fileInputRef,
  handleFileChange,
  handleButtonClick,
}) {
  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: 1100,
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        gap: 3,
        justifyContent: "center",
        alignItems: "stretch",
      }}
    >
      {/* Download Section */}
      <DownloadSection
        filePath={mission?.task?.filePath}
        title="Download Mission PDF"
      />

      {/* Timer Section */}
      <TimerSection
        timeLeft={timeLeft}
        canSubmit={mission?.missionSubmissionStatus?.canSubmit}
        title="Time Left to Submit"
      />

      {/* Upload Section */}
      <Paper
        elevation={4}
        sx={{
          flex: 1,
          p: { xs: 3, md: 5 },
          borderRadius: 5,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          background: "#fff",
          minWidth: 260,
          boxShadow: "0 4px 32px 0 #b3b3b320",
        }}
      >
        <CloudUploadIcon
          sx={{
            fontSize: 60,
            color: config.PRIMARY_COLOR,
            mb: 1,
          }}
        />
        <Typography
          variant="h6"
          sx={{ mb: 2, fontWeight: 700, fontSize: 18 }}
        >
          Upload Your Solution
        </Typography>
        <Typography
          variant="body2"
          sx={{
            mb: 2,
            color: "text.secondary",
            textAlign: "center",
            fontSize: 14,
          }}
        >
          Maximum file size: {FILE_UPLOAD.MAX_SIZE}MB
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column" },
            alignItems: "center",
            gap: 2,
            justifyContent: "center",
            mb: 2,
          }}
        >
          <input
            id="zip-upload-input"
            type="file"
            accept={FILE_UPLOAD.ACCEPTED_TYPES}
            ref={fileInputRef}
            onChange={handleFileChange}
            disabled={
              uploading || !mission?.missionSubmissionStatus?.canSubmit
            }
            style={{ display: "none" }}
          />
          <PrimaryButton
            classBtn={"center"}
            btnType={"button"}
            text={uploading ? "Uploading..." : "Choose File"}
            click={handleButtonClick}
            style={{
              textTransform: "capitalize",
              borderRadius: "5px",
              color: config.SECONDARY_COLOR,
              backgroundColor: config.PRIMARY_COLOR,
              height: "44px",
              minWidth: "180px",
              opacity:
                uploading || !mission?.missionSubmissionStatus?.canSubmit
                  ? 0.6
                  : 1,
              pointerEvents:
                uploading || !mission?.missionSubmissionStatus?.canSubmit
                  ? "none"
                  : "auto",
              cursor:
                uploading || !mission?.missionSubmissionStatus?.canSubmit
                  ? "not-allowed"
                  : "pointer",
              fontWeight: 700,
              fontSize: 18,
              boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
              marginTop: 0,
            }}
            disabled={
              uploading || !mission?.missionSubmissionStatus?.canSubmit
            }
          />
          {selectedFile && (
            <Typography
              sx={{
                fontSize: 15,
                color: "#333",
                maxWidth: 180,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {selectedFile.name}
            </Typography>
          )}
        </Box>
        {uploadStatus && (
          <Typography
            sx={{
              color: uploadStatus.includes("success")
                ? "success.main"
                : uploadStatus.includes("failed") ||
                  uploadStatus.includes("error")
                ? "error.main"
                : "info.main",
              fontWeight: 500,
              mt: 2,
              fontSize: 16,
              textAlign: "center",
            }}
          >
            {uploadStatus}
          </Typography>
        )}
        {uploading && (
          <Box sx={{ width: "100%", mt: 2 }}>
            <LinearProgress
              variant="determinate"
              value={uploadProgress}
              sx={{
                width: "100%",
                borderRadius: "5px",
                height: "8px",
                "& .MuiLinearProgress-bar": {
                  backgroundColor: config.PRIMARY_COLOR,
                },
                "& .MuiLinearProgress-root": {
                  backgroundColor: "#e0e0e0",
                },
              }}
            />
            <Typography
              sx={{
                color: "text.secondary",
                fontSize: 14,
                mt: 1,
                textAlign: "center",
              }}
            >
              {Math.round(uploadProgress)}% uploaded
            </Typography>
          </Box>
        )}
      </Paper>
    </Box>
  );
}

export default FileUploadInterface;

